import Vue from 'vue'
import Vuex from 'vuex'
import lesseeModule from './lessee'
import othersModule from './others'
import rentAdjustmentModule from '../components/RentAdjustment/Store'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        lessee: lesseeModule,
        others: othersModule,
        rentAdjustment: rentAdjustmentModule,
    },
})



// WEBPACK FOOTER //
// ./src/store/index.js